// extracted by mini-css-extract-plugin
export default {"app":"DataTopProject_app__ACSVn"};